/**
 * The Resolution chip of a push row, in Activity's words (UX C4): sent · capped · already set · no price change ·
 * simulated · not sent, and the write log's own word for the rest (`sentStyleOf`). Pure.
 */
import { sentStyleOf } from '../../Activity/@services/sendStyle.js'

const OWN = {
	sent: { tone: 'ok', label: 'sent' },
	capped: { tone: 'warn', label: 'capped' },
	already_set: { tone: 'neutral', label: 'already set' },
	no_price_change: { tone: 'neutral', label: 'no price change' },
	simulated: { tone: 'accent', label: 'simulated' },
	not_sent: { tone: 'info', label: 'not sent' },
}

export function resolutionStyle(push) {
	const r = push?.resolution
	if (OWN[r]) return OWN[r]
	return sentStyleOf(push?.write_status || r || 'not_sent')
}
